import styled from 'styled-components';

import { color } from '~/assets/styles/colors';
import BackgroundLucree from '~/assets/img/backgroundLucrEE.png';
import LogoImage from '~/assets/img/logo-login.png';
import { Button } from 'reactstrap';

export const Container = styled.div`
	display: flex;
	align-items: center;
	height: 100vh;
	background-color: ${color.gray};
`;

export const Box = styled.div`
	max-width: 500px;
	width: 90%;
	margin: 0 auto;
	padding: 50px 24px;
	background-color: ${color.white};
	position: relative;
	z-index: 1;
	border-radius: 0 25px 0px 0px;
	box-shadow: 0px 16px 32px rgba(74, 74, 73, 0.16);

	.rowButton {
		margin-top: 10px;
	}

	.buttonComponent {
		width: 100%;
		padding: 16px;
		border-radius: 15px;

		color: ${color.softBlack} !important;
		background-color: ${color.primary}  !important;
		border: 3px solid ${color.primary} !important;

		&:hover,
		&:focus {
			color: ${color.primary}  !important;
			background-color: #fff  !important;
		}
	}

	.bt-sm .btn-primary {
		min-height: 30px !important; /* Defina a altura mínima conforme necessário */
	}

	.buttonComponentOutline {
		width: 100%;
		padding: 16px;
		border-radius: 15px;
		color: ${color.primary};
		border: 3px solid ${color.primary} !important;
		background-color: #fff  !important;
		display: inline-block;
		white-space: nowrap;

		&:hover,
		&:focus {
			color: #fff !important;
			background-color: ${color.primary}  !important;
		}
	}

	.buttonComponentToken {
		width: 100%;
		padding: 5px !important;
		border: none;
		color: ${color.primary};
		background-color: #fff  !important;

		transition: all ease 0.5s;

		&:hover,
		&:focus {
			border-radius: 15px;
			color: ${color.secondary};
			background-color: ${color.grayLight}  !important;
		}
	}
`;

export const Background = styled.div`
	width: 100%;
	height: 100%;
	background-color: ${color.primary};
	background-image: linear-gradient(
			to bottom,
			rgba(141, 253, 193, 0.7),
			rgba(141, 253, 193, 0.7)
		),
		url(${BackgroundLucree});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	position: fixed;
`;

export const Logo = styled.div`
	width: 100%;
	height: 64px;
	background-image: url(${LogoImage});
	background-repeat: no-repeat;
	background-position: center;
	background-size: 225px;
	margin-bottom: 70px;
`;

export const ForgotPassword = styled.p`
	font-size: 28px;
	color: ${color.grayDark};
	font-weight: bold;
`;

export const ButtonSecondary = styled(Button)`
	font-weight: bold ;
	width: 100%;
	padding: 16px;
	border-radius: 15px;

	color: ${color.softBlack} !important;
	background-color: ${color.secondary}  !important;
	border: 3px solid ${color.secondary} !important;

	&:hover,
    &:focus{
		color:  ${color.secondary} !important;
		background-color: #fff  !important;
    }
`;
